export default __webpack_public_path__ + "static/media/Arm_left.7093bfcc.svg";